import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-101">
      <div className="max-w-4xl mx-auto" data-id="element-102">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden relative border border-gray-100" data-id="element-103">
          {/* Decorative blurs */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 -translate-y-1/2" data-id="element-104"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-green-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 translate-y-1/2" data-id="element-105"></div>

          <div className="relative p-8 md:p-12 flex flex-col md:flex-row items-center gap-10" data-id="element-106">
            {/* Left: Seal */}
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-107">
              <div className="relative w-48 h-48 flex items-center justify-center" data-id="element-108">
                {/* Animated dashed border */}
                <div className="absolute inset-0 rounded-full border-4 border-dashed border-blue-300 animate-spin-slow" data-id="element-109"></div>
                {/* Inner circle */}
                <div className="absolute inset-2 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex flex-col items-center justify-center text-white shadow-inner" data-id="element-110">
                  <ShieldCheckIcon className="w-12 h-12 mb-2" data-id="element-111" />
                  <span className="text-2xl font-black leading-none text-center" data-id="element-112">
                    45
                    <br data-id="element-113" />
                    <span className="text-sm tracking-widest" data-id="element-114">GIORNI</span>
                  </span>
                  <span className="text-[10px] uppercase font-bold tracking-wider mt-1" data-id="element-115">
                    Garanzia
                  </span>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-116">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-117">
                Garanzia di Soddisfazione 100%
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-118">
                Siamo così sicuri che adorerai queste ricette che ti offriamo
                una garanzia di ferro. Prova il libro per 45 giorni.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-left" data-id="element-119">
                {['Nessun rischio per te', 'Rimborso completo del 100%', 'Senza fare domande', 'Procedura semplice via email'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-120">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-121" />
                    <span className="text-gray-700 font-medium" data-id="element-122">{item}</span>
                  </div>)}
              </div>

              <button onClick={scrollToOffer} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-full shadow-lg transition-transform hover:scale-105 w-full sm:w-auto" data-id="element-123">
                Prova senza rischi
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}